const invoices = {
  namespaced: true,
  state: {
    displayInvoiceType: 'Unpaid',
  },
  mutations: {
    setDisplayInvoiceType(state, { display }) {
      state.displayInvoiceType = display;
    },
  },
};

export default invoices;
